import { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import { useAuthStore } from '@bloomays-lib/common.auth/browser';
import EmptyState from '../molecules/Emptystate';
import { FileViewer } from '../molecules/FileViewer';
import emptyImage from '../../assets/empty.svg';

type TalentCVProps = {
  emptyText: string;
  cv?: string | null;
  emptySx?: React.CSSProperties;
};

const TalentCV = ({ emptyText, cv, emptySx }: TalentCVProps) => {
  const [token, setToken] = useState<string | undefined>();
  const auth = useAuthStore((state) => state.auth);

  useEffect(() => {
    if (auth?.getAccessTokenSilently) {
      auth.getAccessTokenSilently().then((accessToken) => {
        setToken(accessToken);
      });
    }
  }, [auth]);

  const isLegacyCVLinkedinURL = cv?.includes('linkedin');

  if (!cv || isLegacyCVLinkedinURL) {
    return (
      <EmptyStateContainer emptySx={emptySx}>
        <EmptyState image={emptyImage} text={emptyText || ''} />
      </EmptyStateContainer>
    ) as React.ReactNode;
  }

  return (
    <FileViewerContainer>
      <FileViewer accessToken={token} url={cv} height="1000" />
    </FileViewerContainer>
  ) as React.ReactNode;
};

const EmptyStateContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'emptySx',
})(({ emptySx }: { emptySx?: React.CSSProperties }) => ({
  display: 'flex',
  justifyContent: 'center',
  ...(emptySx || {}),
}));

const FileViewerContainer = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'center',
}));

export { TalentCV };
export default TalentCV;
